// removed by extract-text-webpack-plugin
module.exports = {"authorizationError":"AuthorizationError__authorizationError","title":"AuthorizationError__title","mobile":"AuthorizationError__mobile","message":"AuthorizationError__message","whyAuthorize":"AuthorizationError__whyAuthorize","growDotQello":"AuthorizationError__growDotQello","growDotBlue":"AuthorizationError__growDotBlue","growDotGolden":"AuthorizationError__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationError/AuthorizationError.scss
// module id = 1892
// module chunks = 0